import React from 'react';
import Dialog from '@material-ui/core/Dialog'
import styles from './style.module.css' 
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import Table from "../../../views/Table/Table.js";
import BarCodeComp from './barcodePrint/BarCode'

const WareHouseDetail = (props) => {
    let goDown = [];
    let location = [];
    props.warehouse.godownDetails.forEach(val => {
        val &&
        goDown.push(
            [
                val.name,
                val.godown_barcode
            ]
        )
    });
    props.warehouse.location.forEach(val => {
        val &&
        location.push(
            [
                val.godown ? val.godown.name : "",
                val.name, 
                val.location_barcode,
                <BarCodeComp location={val} warehouse={props.warehouse}/>
            ]
        )
    });

    
    return (
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'lg'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>Ware House Detail</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>
                    <div className={styles.content}>
                        <div className={styles.row}>
                            <p>
                                Name: 
                                <span>{props.warehouse.name}</span>
                            </p>

                            <p>
                                Ware House Location: 
                                <span>{props.warehouse.warehouseLocation}</span>
                            </p>
                        </div>
                        <div className={styles.row}>
                            <p>
                                Contact Number: 
                                <span>{props.warehouse.contactNum}</span>
                            </p>

                            <p>
                                Address: 
                                <span>{props.warehouse.address}</span>
                            </p>
                        </div>
                    </div>

                    <h2>Godown Details</h2>

                    <Table
                        tableHeaderColor="primary"
                        tableHead={["Name","BarCode"]}
                        tableData={goDown}
                    /> 

                    <h2>Locations</h2>

                    <Table
                        tableHeaderColor="primary"
                        tableHead={["Godown","Name","Barcode","View BarCode"]}
                        tableData={location}
                    /> 
                </div>
            </div>
        </Dialog>
    )
}

export default WareHouseDetail;